import { FinalCta } from '@/components/creve/FinalCta';
import { HeroSection } from '@/components/creve/HeroSection';
import { LandingFooter } from '@/components/creve/LandingFooter';
import { LandingHeader } from '@/components/creve/LandingHeader';
import { SolvesSection } from '@/components/creve/SolvesSection';
import { TrustStrip } from '@/components/creve/TrustStrip';
import { VerifiedShowcase } from '@/components/creve/VerifiedShowcase';
import { PageLayout } from '@/components/poof-ui';
import React from 'react';

export const HomePage: React.FC = () => {
  return (
    <PageLayout fullBleed footer={<LandingFooter />}>
      <LandingHeader />
      <HeroSection />
      <TrustStrip />
      <SolvesSection />
      <VerifiedShowcase />
      <FinalCta />
    </PageLayout>
  );
};

export default HomePage;
